import { render } from "./system-config.vue?vue&type=template&id=4515245b"
import script from "./system-config.vue?vue&type=script&lang=js"
export * from "./system-config.vue?vue&type=script&lang=js"

import exportComponent from "/data/soft/jenkins/jobs/release-ms-front/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__